import React from "react";

export default function TermsAndConditions() {
  return (
    <>
      {/* Inline styles for Terms & Conditions page */}
      <style>{`
        body {
          background-image: url('/F.jpg');
          background-size: cover;
          background-position: center;
          background-repeat: no-repeat;
          font-family: 'Poppins', sans-serif;
          margin: 0;
        }
        .terms-main-container {
          margin: 2rem auto;
          padding: 2rem;
          max-width: 800px;
          background-color: rgba(255, 255, 255, 0.164);
          box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.363);
          backdrop-filter: blur(30px);
          border: 2px solid rgba(255, 255, 255, 0.24);
          border-radius: 20px;
        }
        .terms-header {
          text-align: center;
          margin-bottom: 1rem;
        }
        .terms-header h1 {
          font-size: 2rem;
          color: rgb(15, 133, 202);
          margin-bottom: 0.5rem;
        }
        .terms-header hr {
          border: none;
          border-top: 2px solid rgba(15, 133, 202, 0.5);
          margin: 0 auto;
          width: 50%;
        }
        .first-block {
          margin-top: 2rem;
        }
        .terms-title {
          font-size: 1.5rem;
          color: rgb(15, 133, 202);
          margin-bottom: 0.5rem;
        }
        .terms-info {
          color: white;
          font-size: 1rem;
          line-height: 1.5;
          margin-bottom: 1rem;
        }
        .term-list {
          margin-left: 1.5rem;
          color: white;
          font-size: 0.9rem;
          list-style: disc;
          margin-bottom: 1rem;
        }
        .ending-terms {
          color: rgb(216, 225, 255);
          text-align: center;
          margin-top: 2rem;
          font-style: italic;
        }
      `}</style>

      <div className="terms-main-container">
        {/* Company Logo */}
        <img src="/wayuvega.png" alt="Wayuvega Logo" className="w-48 mt-4 mx-auto" />

        <section className="terms-header">
          <h1>Terms &amp; Conditions</h1>
          <hr />
        </section>

        <div className="terms-body">
          <div className="first-block">
            <p className="terms-title">Introduction</p>
            <p className="terms-info">
              These Terms &amp; Conditions govern your use of the services provided by wayuvega ("we," "our," or "us"), located at 163/156, Badarpur, New Delhi. By using our services, you agree to these terms. If you do not agree, please refrain from using our services.
            </p>
          </div>

          <div className="first-block">
            <p className="terms-title">Eligibility</p>
            <p className="terms-info">
              By using our services, you confirm that you are at least 18 years old and capable of entering into a legally binding agreement. If you are accessing our services on behalf of a company or organization, you represent that you are authorized to bind that entity to these terms.
            </p>
          </div>

          <div className="first-block">
            <p className="terms-title">Services Provided</p>
            <p className="terms-info">
              wayuvega is a logistics company providing integration and delivery solutions. Specific details of our services are outlined in individual agreements or service-level agreements (SLAs) with our clients.
            </p>
          </div>

          <div className="first-block">
            <p className="terms-title">User Obligations</p>
            <p className="terms-info">By using our services, you agree to:</p>
            <ul className="term-list">
              <li>Provide accurate and complete information.</li>
              <li>Use our services only for lawful purposes.</li>
              <li>Comply with all applicable laws and regulations.</li>
            </ul>
          </div>

          <div className="first-block">
            <p className="terms-title">Prohibited Activities</p>
            <p className="terms-info">You must not:</p>
            <ul className="term-list">
              <li>Misuse our platform or services.</li>
              <li>Engage in any fraudulent or harmful activities.</li>
              <li>Attempt to interfere with our systems or data.</li>
            </ul>
          </div>

          <div className="first-block">
            <p className="terms-title">Intellectual Property</p>
            <p className="terms-info">
              All content, trademarks, logos, and intellectual property on our website and platforms are the exclusive property of wayuvega unless otherwise stated. Unauthorized use of our intellectual property is strictly prohibited.
            </p>
          </div>

          <div className="first-block">
            <p className="terms-title">Privacy Policy</p>
            <p className="terms-info">
              Your use of our services is also governed by our Privacy Policy, which outlines how we collect, use, and protect your personal information.
            </p>
          </div>

          <div className="first-block">
            <p className="terms-title">Indemnification</p>
            <p className="terms-info">
              You agree to indemnify and hold wayuvega harmless from any claims, damages, or expenses arising from your violation of these Terms &amp; Conditions or your use of our services.
            </p>
          </div>

          <div className="first-block">
            <p className="terms-title">Limitation of Liability</p>
            <p className="terms-info">wayuvega will not be liable for:</p>
            <ul className="term-list">
              <li>Any indirect, incidental, or consequential damages arising from the use of our services.</li>
              <li>Losses resulting from delays or service interruptions.</li>
              <li>Unauthorized access to your data unless caused by our gross negligence.</li>
            </ul>
          </div>

          <div className="first-block">
            <p className="terms-title">Termination</p>
            <p className="terms-info">
              We reserve the right to terminate or suspend your access to our services without notice if you violate these terms or engage in unlawful activity.
            </p>
          </div>

          <div className="first-block">
            <p className="terms-title">Governing Law</p>
            <p className="terms-info">
              These terms are governed by the laws of India. Any disputes arising from these terms shall be resolved exclusively in the courts of New Delhi.
            </p>
          </div>

          <div className="first-block">
            <p className="terms-title">Changes to Terms</p>
            <p className="terms-info">
              We may update these terms from time to time. Any changes will be communicated via our website or other official channels. Continued use of our services after changes indicates your acceptance of the revised terms.
            </p>
          </div>

          <p className="ending-terms">
            Thank you for choosing wayuvega! We look forward to serving you.
          </p>
        </div>
      </div>
    </>
  );
}
